// quantity-bundle-cro.js
// Funcionalidade para o Bundle de Quantidade - Versão CRO

class QuantityBundleCro {
  constructor(container) {
    this.container = container;
    this.productId = container.dataset.productId;
    this.radioButtons = container.querySelectorAll('.qb__radio');
    this.buyButton = container.querySelector('.qb__cta');
    this.comparePriceEl = container.querySelector('.qb__compare-price');
    this.currentPriceEl = container.querySelector('.qb__current-price');
    this.pixPriceEl = container.querySelector('.qb__pix-price');

    this.baseComparePrice = parseFloat(this.comparePriceEl.dataset.comparePrice) / 100;
    this.baseCurrentPrice = parseFloat(this.currentPriceEl.dataset.currentPrice) / 100;
    this.pixDiscount = parseFloat(this.pixPriceEl.dataset.pixDiscount) || 1;

    // Capturar descontos por quantidade
    this.quantityDiscounts = {};

    const options = this.container.querySelectorAll('.qb__card');
    options.forEach(option => {
      const quantity = parseInt(option.dataset.quantity);
      if (quantity) {
        const optionIndex = Array.from(options).indexOf(option) + 1;
        const discountAttr = `option${optionIndex}Discount`;
        const discountValue = parseFloat(
          container.dataset[discountAttr] ||
          container.getAttribute(`data-option-${optionIndex}-discount`)
        ) || 0;

        this.quantityDiscounts[quantity] = discountValue;
      }
    });

    this.selectedQuantity = this.getSelectedQuantity();

    this.init();
  }

  init() {
    this.bindEvents();
    this.updatePrices();
    this.setupButton();
  }

  setupButton() {
    this.originalButtonHTML = this.buyButton.innerHTML;
    this.originalButtonStyle = this.buyButton.style.background;
  }

  bindEvents() {
    this.radioButtons.forEach(radio => {
      radio.addEventListener('change', (e) => {
        this.selectedQuantity = parseInt(e.target.value);
        this.updatePrices();
      });
    });

    this.buyButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.addToCart();
    });

    // Click on card selects radio
    this.container.querySelectorAll('.qb__card').forEach(card => {
      card.addEventListener('click', (e) => {
        if (e.target.type !== 'radio' && !e.target.closest('label')) {
          const radio = card.querySelector('.qb__radio');
          if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change'));
          }
        }
      });
    });
  }

  getSelectedQuantity() {
    const checkedRadio = this.container.querySelector('.qb__radio:checked');
    return checkedRadio ? parseInt(checkedRadio.value) : 1;
  }

  updatePrices() {
    const quantity = this.selectedQuantity;

    const quantityDiscountPercent = this.quantityDiscounts[quantity] || 0;
    const quantityDiscountDecimal = quantityDiscountPercent / 100;

    const totalComparePrice = this.baseComparePrice * quantity;
    const totalCurrentPriceBeforeDiscount = this.baseCurrentPrice * quantity;
    const totalCurrentPrice = totalCurrentPriceBeforeDiscount * (1 - quantityDiscountDecimal);

    const pixDiscountDecimal = this.pixDiscount / 100;
    const totalPixPrice = totalCurrentPrice * (1 - pixDiscountDecimal);

    this.comparePriceEl.textContent = this.formatPrice(totalComparePrice);
    this.currentPriceEl.textContent = this.formatPrice(totalCurrentPrice);

    const pixText = this.pixPriceEl.textContent.split(' ').slice(-2).join(' ');
    this.pixPriceEl.innerHTML = `${this.formatPrice(totalPixPrice)} ${pixText}`;
  }

  formatPrice(price) {
    return 'R$' + price.toFixed(2).replace('.', ',');
  }

  async addToCart() {
    if (this.buyButton.disabled) return;

    try {
      this.buyButton.disabled = true;
      this.buyButton.innerHTML = '<span class="qb__cta-text">Processando...</span>';

      const productData = await this.fetchProductData();
      const variantId = productData.variants[0].id;

      // Limpar carrinho e adicionar produto
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: this.selectedQuantity })
      });

      if (response.ok) {
        this.buyButton.innerHTML = '<span class="qb__cta-text">Redirecionando...</span>';
        window.location.href = '/checkout';
      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Erro ao adicionar produto ao carrinho');
      }
    } catch (error) {
      console.error('Erro:', error);
      this.showErrorFeedback();
    }
  }

  async getCartWithSections(sections = []) {
    try {
      const body = JSON.stringify({ sections });
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body
      });
      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar carrinho com seções:', error);
      return await this.getCartState();
    }
  }

  async fetchProductData() {
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      return window.ShopifyAnalytics.meta.product;
    }
    const handle = this.getProductHandle();
    if (handle) {
      const response = await fetch(`/products/${handle}.js`);
      return await response.json();
    }
    throw new Error('Não foi possível obter dados do produto');
  }

  getProductHandle() {
    // Primeiro tenta pegar do data attribute (funciona em landing pages)
    const handleAttr = this.container.dataset.productHandle;
    if (handleAttr) return handleAttr;

    // Fallback: tenta pegar da URL (funciona em páginas de produto)
    const path = window.location.pathname;
    const match = path.match(/\/products\/([^\/]+)/);
    return match ? match[1] : null;
  }

  showSuccessFeedback() {
    this.buyButton.innerHTML = '<span class="qb__cta-text">Adicionado!</span>';
    this.buyButton.style.background = '#16a34a';
    setTimeout(() => { this.restoreButton(); }, 2000);
  }

  showErrorFeedback() {
    this.buyButton.innerHTML = '<span class="qb__cta-text">Erro - Tente novamente</span>';
    this.buyButton.style.background = '#dc2626';
    setTimeout(() => { this.restoreButton(); }, 3000);
  }

  restoreButton() {
    this.buyButton.disabled = false;
    this.buyButton.innerHTML = this.originalButtonHTML;
    this.buyButton.style.background = this.originalButtonStyle || '';
  }

  async getCartState() {
    try {
      const response = await fetch('/cart.js');
      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar estado do carrinho:', error);
      return null;
    }
  }

  openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.show === 'function') {
      cartDrawer.show();
      return;
    }

    const cartDrawerById = document.getElementById('CartDrawer');
    if (cartDrawerById && typeof cartDrawerById.show === 'function') {
      cartDrawerById.show();
      return;
    }

    document.dispatchEvent(new CustomEvent('cart:open-drawer', {
      bubbles: true,
      detail: { source: 'quantity-bundle' }
    }));

    const cartIcon = document.querySelector('[data-cart-toggle], cart-icon, #cart-icon-bubble');
    if (cartIcon) {
      cartIcon.click();
      return;
    }

    const anyDrawer = document.querySelector('.cart-drawer, [role="dialog"][aria-label*="cart"]');
    if (anyDrawer) {
      anyDrawer.removeAttribute('hidden');
      anyDrawer.classList.add('active');
      anyDrawer.classList.remove('pointer-events-none');

      const overlay = anyDrawer.querySelector('overlay-element, .overlay');
      if (overlay) {
        overlay.classList.remove('invisible', 'opacity-0');
        overlay.classList.add('visible', 'opacity-100');
      }
    }
  }
}

// Init
function initQuantityBundlesCro() {
  const bundles = document.querySelectorAll('.qb');
  bundles.forEach(bundle => {
    if (!bundle.dataset.croInit) {
      bundle.dataset.croInit = 'true';
      new QuantityBundleCro(bundle);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initQuantityBundlesCro);
} else {
  initQuantityBundlesCro();
}

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target;
  const bundles = section.querySelectorAll('.qb');
  bundles.forEach(bundle => {
    bundle.dataset.croInit = '';
    new QuantityBundleCro(bundle);
  });
});

window.QuantityBundleCro = QuantityBundleCro;